module.exports = __webpack_public_path__ + "03d31d336defbdd9c47d7025f8b48085.png";